import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { appApiResources } from '../../../configuration/app.constants';

@Injectable({
  providedIn: 'root'
})
export class GetTitleService {

  constructor(private http: HttpClient) { }

  async getAllTitle() {
    try {
      let response = await this.http
        .get(`${appApiResources.getTitle}`)
        .toPromise();
      return response;
    } catch (error) {
      return error;
    }
  }

  getAllTitleSub() {
    return this.http.get(`${appApiResources.getTitle}`)

  }
}
